export default "__VITE_ASSET__C4Xurxx9__"